import { useState, useEffect, useRef } from 'react';
import axios from 'axios';

import Error from './Error';
import CircularLoading from './CircularLoading';
import DividerLine from './DividerLine';
import Filters from './Filters';
import ListingCard from './ListingCard';
import OverflowText from './OverflowText';
import PillsSection from './PillsSection';
import ThumbGallery from './ThumbGallery';

export default function App({
	devRootPath = '',
	apiKey = '',
	loginRedirect = true,
	colour = '#1D3B80',
	variant = 'animals',
	FID,
}) {
	const [errorMsg, setErrorMsg] = useState(false);
	const [pageLoaded, setPageLoaded] = useState(false);
	const path = useRef(window.ESS?.rootPath || devRootPath);
	const apiData = useRef(null);
	const [searchValue, setSearchValue] = useState('');
	const [typeValue, setTypeValue] = useState('');
	const [useValue, setUseValue] = useState('');
	const descriptionField =
		variant === 'animals' ? 'DescriptionOfAnimal' : 'PlantAndUsesDescription';
	const typeField = variant === 'animals' ? 'Type' : 'LifeForm';
	const photosField = variant === 'animals' ? 'AnimalPhotos' : 'PlantPhotos';

	const contentList =
		apiData.current &&
		apiData.current.filter(
			(animal) =>
				(searchValue.length > 0
					? animal.Label?.split(';').filter((el) => searchValue.includes(el)).length > 0 ||
					  animal.CommonName?.split(';').filter((el) => searchValue.includes(el)).length > 0 ||
					  false
					: true) &&
				(typeValue.length > 0
					? animal[variant === 'animals' ? 'Type' : 'LifeForm']
							?.split(';')
							.filter((el) => typeValue.includes(el)).length > 0 || false
					: true) &&
				(useValue.length > 0
					? animal.Uses?.split(';').filter((el) => useValue.includes(el)).length > 0 || false
					: true)
		);

	useEffect(() => {
		axios
			.get(`${path.current}/getdata?FID=${FID}&MODE=ALL&FORMAT=JSON&APIKEY=${apiKey}`)
			.then(({ data }) => {
				if (data === '' || typeof data !== 'object') {
					setErrorMsg(true);
					return;
				}
				apiData.current = data;
			})
			.catch((error) => {
				console.error(error.message);
			})
			.finally(() => setPageLoaded(true));
	}, [path, apiKey, FID]);

	useEffect(() => {
		if (!apiData.current) return;
		apiData.current
			.map((x) => x.EntryId)
			.forEach((id) => {
				const element = document.querySelector(`#desc_${id}`);
				if (!element || element.clientHeight <= 80) return;
				document
					.querySelectorAll(`.overlay_${id}`)
					.forEach((target) => target.classList.remove('!tw-hidden'));
			});
	}, [useValue, typeValue, searchValue]);

	if (errorMsg) {
		return <Error loginRedirect={loginRedirect} path={path.current} />;
	}

	return (
		<>
			{pageLoaded === true ? (
				<div>
					<Filters
						data={apiData.current}
						searchValue={searchValue}
						setSearchValue={setSearchValue}
						typeField={variant === 'animals' ? 'Type' : 'LifeForm'}
						typeValue={typeValue}
						setTypeValue={setTypeValue}
						useValue={useValue}
						setUseValue={setUseValue}
					/>
					<DividerLine />
					<div className='tw-grid tw-grid-cols-[repeat(auto-fill,_minmax(300px,_1fr))] tw-gap-4'>
						{contentList.map((item) => (
							<ListingCard
								key={item.EntryId}
								title={item.Label}
								subtitle={item.ScientificName}
								subtitleTwo={item.CommonName}
								titleTag={item[typeField]}
								path={path}
								imgSrc={item.RepresentativeImage}
								imgWidth={300}
								apikey={apiKey}
								imgAlt={item.Label}>
								<OverflowText
									data={apiData.current}
									dependencies={[useValue, typeValue, searchValue]}
									id={item.EntryId}
									height={80}
									twHeight='tw-max-h-20'
									heading='Description:'
									text={item[descriptionField]}
								/>
								<PillsSection heading='Uses:' data={item.Uses} />
								<ThumbGallery
									heading='Photos'
									galleryID={item.EntryId}
									data={item}
									field={photosField}
									path={path}
									apikey={apiKey}
								/>
							</ListingCard>
						))}
					</div>
				</div>
			) : (
				<CircularLoading colour={colour} />
			)}
		</>
	);
}
